import { render, staticRenderFns } from "./NeoparentUnauthorized.vue?vue&type=template&id=85799e6a&scoped=true"
import script from "./NeoparentUnauthorized.vue?vue&type=script&lang=js"
export * from "./NeoparentUnauthorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85799e6a",
  null
  
)

export default component.exports